import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly supportedLocales = ['es', 'en'] as const;
  readonly locale = signal<'es' | 'en'>('es');

  constructor(private readonly translate: TranslateService) {}

  init(): void {
    this.translate.addLangs([...this.supportedLocales]);
    this.translate.setDefaultLang('es');

    const saved = localStorage.getItem('language');
    const initial = saved === 'en' || saved === 'es' ? saved : 'es';
    this.setLocale(initial);
  }

  setLocale(locale: 'es' | 'en'): void {
    localStorage.setItem('language', locale);
    this.translate.use(locale);
    this.locale.set(locale);
  }
}
